/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { Badge } from '@material-ui/core'
import { Menu, ShoppingCartOutlined } from '@material-ui/icons'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { setAlert } from '../../../flux/alert'
import styled from 'styled-components'
import FloatButtons from './floatButtons';

const LogoMobile = styled.img`
  max-width: 100%;
  width: 190px;
`
const LiHideSmall = styled.li`
  @media (max-width:990px) {
    display: none;
  }
`
const CustomizedBadges = (props) => {
  const itemsOnTheCart = useSelector(state => state.cart)

  return (
    <Badge badgeContent={itemsOnTheCart.length} color='secondary'>
      <ShoppingCartOutlined />
    </Badge>
  )
}

const Header = (props) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const itemsOnTheCart = useSelector(state => state.cart)

  function handlePreventLeave (event) {
    if (itemsOnTheCart.length) {
      const to = event.currentTarget.href
      event.preventDefault()
      dispatch(setAlert({
        action: () => { window.location = to },
        message: 'Se perderán los estudios agregados al carrito de compras',
        title: '¿Seguro que quieres salir?'
      }))
    }
  }

  return (
    <>
      <div id='menu-navegacion' style={{ zIndex: 99, position: 'sticky', width: '100%', willChange: 'transform', transform: 'translateZ(0px)' }}>
      <div className='logo-nav d-none d-sm-block'>
        <a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/index.php' className='logo'>
          <img className='img-logo-resp' src='https://www.laboratoriosiml.com/images/iml-laboratorio-medico-logo.svg' alt='Logo del sitio' />
        </a>
      </div>

      <nav className='navbar navbar-dark bg-primary navbar-expand-lg py-3 pr-xl-4 nav-responsive'>
        <button type='button' className='navbar-toggler collapsed' data-toggle='collapse' data-target='#menu-principal' aria-expanded='true'>
          <Menu />
        </button>
        <div className='d-block d-sm-none'>
          <a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/index.php' className='logo'>
            <LogoMobile className='img-logo-resp' src='https://www.laboratoriosiml.com/images/iml-laboratorio-medico-logo-footer.svg' alt='Logo del sitio' />
          </a>
        </div>
        <div type='button' className='navbar-toggler collapsed' data-toggle='collapse' aria-expanded='true'>
          <Link to='/my-cart' className='nav-link active' style={{ paddingRight: '11px', paddingLeft: '0px' }}>
            <CustomizedBadges />
          </Link>
        </div>

        <a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/muestra.php' className='btn btn-secondary order-lg-1 texto-menu px-2 mr-3 d-none d-lg-block'>Toma de muestra a domicilio</a>
        <a onClick={handlePreventLeave} href='http://sassintermedic.dyndns.org/resultados/index.asp' target='_blank' className='btn btn-celeste order-lg-1 texto-menu px-2 d-none d-lg-block'>Consulta de Resultados</a>

        <div className='row d-block d-lg-none w-100 text-center margen-boton-menu'>
          <a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/muestra.php' className='btn btn-secondary order-lg-1 texto-menu px-2 mr-1 mt-3 mt-sm-0 d-block d-sm-inline'>Toma de muestra a domicilio</a>
          <a onClick={handlePreventLeave} href='http://sassintermedic.dyndns.org/resultados/index.asp' target='_blank' className='btn btn-celeste order-lg-1 texto-menu px-2 mt-3 mt-sm-0 d-block d-sm-inline'>Consulta de Resultados</a>
        </div>

        <div className='navbar-collapse texto-menu collapse' id='menu-principal' style={{ fontSize: '14px' }}>
          <ul style={{ alignItems: 'center' }} className='navbar-nav text-center mt-3 mt-lg-0 ml-lg-auto pr-lg-1 pr-xl-3 hover-movile'>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-2'><a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/index.php' className='nav-link'>Inicio</a>
            </li>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-2'><a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/servicios.php' className='nav-link '>Servicios</a>
            </li>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-2'><a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/empresas.php' className='nav-link '>Empresas</a>
            </li>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-2'><a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/medicos.php' className='nav-link '>Médicos</a>
            </li>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-0'>
              <Link to='/tienda' className='nav-link active'>Tienda</Link>
              {location.pathname === '/tienda' && (
                <div className='active-line-home' />
              )}
            </li>
            <LiHideSmall className='nav-item mb-1 mb-lg-0 mr-lg-0'>
              <Link to='/my-cart' className='nav-link active'>
                <CustomizedBadges />
              </Link>
              {location.pathname === '/my-cart' && (
                <div className='active-line-home' />
              )}

            </LiHideSmall>
            <li className='nav-item mb-1 mb-lg-0 mr-lg-0'><a onClick={handlePreventLeave} href='https://www.laboratoriosiml.com/contacto.php' className='nav-link '>Contacto</a>
            </li>
          </ul>
        </div>
      </nav>

      <div className='row texto-menu'>
        <div className='col-12 offset-lg-3 col-lg-9 pr-lg-5 bg-rojo header-link'>
          <p className='text-white text-min mb-0 py-2 py-lg-3 text-center text-lg-right texto-emergencias'><strong>Urgencias 24 horas:</strong> <a onClick={handlePreventLeave} href='tel:4423830541'>Querétaro (442) 383 0541</a> / <a onClick={handlePreventLeave} href='tel:4271859326'>San Juan del Río (427) 185 9326 </a></p>
        </div>
      </div>
      
    </div>
    <FloatButtons />
    </>
  )
}

export default Header
